export default {
    SYSTEM_ID: "swade",
    imageReplacerDamageType: [],
    imageReplacerWeaponProperties: [],
    imageReplacerIconizer: [],
};
